(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    document.querySelectorAll('footer-menu details').forEach((detail) => {
      detail.setAttribute('open', 'true');
    });

    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        this.disclosure.open = true; // <– Håller ALLTID öppen, även på mobil
        this.toggle?.setAttribute('tabindex', '-1');
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-accessory-preview"]) return;
  try {
    
const accessoryPreviewView = new URLSearchParams(window.location.search).get('view');
if (accessoryPreviewView === 'zs-activity-straps') {
  document.addEventListener('on:variant:change', () => {
    const previewUrl = new URL(window.location.href);
    previewUrl.searchParams.set('view', accessoryPreviewView);
    window.history.replaceState(window.history.state, '', previewUrl);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-accessory-tools"]) return;
  try {
    
const accessoryView = new URLSearchParams(window.location.search).get('view');
const prepareAccessoryColors = (picker) => {
  if (!document.querySelector('.zs-accessory-intro') || !picker) return;
  const colorGroup = picker.querySelector('fieldset.option-selector');
  if (!colorGroup) return;
  const colors = [...colorGroup.querySelectorAll('input[type="radio"]')];
  const possible = colors.filter((input) => !input.classList.contains('is-nonexistent'));
  if (colors.length === 1) colorGroup.hidden = true;
  if (possible.length === 1 && !possible[0].checked && (colors.length === 1 || picker.selectedOptions?.[0])) {
    possible[0].click();
  }
};
document.addEventListener('on:variant:change', (event) => {
  if (!document.querySelector('.zs-accessory-intro')) return;
  prepareAccessoryColors(event.target.closest('variant-picker'));
  if (accessoryView === 'zs-activity-straps') {
    const url = new URL(window.location.href);
    url.searchParams.set('view', accessoryView);
    window.history.replaceState(window.history.state, '', url);
  }
});
const initializeAccessoryChoices = () => prepareAccessoryColors(document.querySelector('variant-picker'));
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAccessoryChoices);
else initializeAccessoryChoices();
document.addEventListener('shopify:section:load', initializeAccessoryChoices);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-collection-quick-filter"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zs-collection-filter')) {
  customElements.define('zs-collection-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const init = () => {
        const grid = document.querySelector('.main-products-grid');
        if (!grid) return;
        const items = Array.from(grid.querySelectorAll('.grid > li.js-pagination-result:not([class*=promo-item])'));
        if (!items.length) return;
        const originalItems = [...items];
        const prices = JSON.parse(this.querySelector('[data-product-prices]').textContent);
        const handleFor = item => {const link=item.querySelector('a.js-prod-link');return link ? new URL(link.href).pathname.split('/products/')[1]?.split('/')[0] : '';};
        this.querySelector('select').addEventListener('change', event => {
          const sorted = [...originalItems];
          if (event.target.value !== 'recommended') sorted.sort((a,b) => (prices[handleFor(a)] - prices[handleFor(b)]) * (event.target.value === 'price-low' ? 1 : -1));
          sorted.forEach(item => item.parentElement.appendChild(item));
        });
        const inputs = Array.from(this.querySelectorAll('input[type=checkbox]'));
        const apply = () => {
          const selected = inputs.filter(input => input.checked);
          const handles = new Set(selected.flatMap(input => input.dataset.handles.split(',').filter(Boolean)));
          grid.querySelectorAll('.grid > li[class*="promo-item"]').forEach(promo => {promo.hidden = selected.length > 0;});
          let count = 0;
          items.forEach(item => {
            const link = item.querySelector('a.js-prod-link');
            const handle = link ? new URL(link.href).pathname.split('/products/')[1]?.split('/')[0] : '';
            item.hidden = selected.length > 0 && !handles.has(handle);
            if (!item.hidden) count += 1;
          });
          this.querySelector('.zs-filter-count').textContent = `${count} ${this.dataset.results}`;
          const badge = this.querySelector('.zs-filter-badge');
          badge.textContent = selected.length;
          badge.hidden = selected.length === 0;
          this.querySelector('details').open = false;
          document.dispatchEvent(new Event('scroll'));
        };
        this.querySelector('[data-apply]').addEventListener('click', apply);
        this.querySelector('[data-reset]').addEventListener('click', () => {inputs.forEach(input => {input.checked = false;});apply();});
        document.addEventListener('pointerdown', event => {if (!this.contains(event.target)) this.querySelector('details').open = false;});
        this.addEventListener('keydown', event => {if (event.key === 'Escape') {this.querySelector('details').open = false;this.querySelector('summary').focus();}});
        this.setAttribute('data-ready', '');
        apply();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
      else init();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-organizer-feature"] && !Shopify.designMode) return;
  try {
    
const initFeatureVideos = (root) => {
  root.querySelectorAll('.zs-org-feature__video').forEach((video) => {
    if (video.dataset.observed) return;
    video.dataset.observed = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) video.play().catch(() => {});
        else video.pause();
      });
    }, { threshold: 0.2 });
    observer.observe(video);
  });
};
initFeatureVideos(document);
document.addEventListener('shopify:section:load', (event) => initFeatureVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-organizer-styles"]) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#zs-org-accessories"]');
  if (!link) return;
  const details = document.getElementById('zs-org-accessories');
  if (details) details.open = true;
});
const updateOrganizerStickyLabel = () => {
  const intro = document.querySelector('.zs-organizer-intro');
  const link = document.querySelector('sticky-atc-panel a[href="#variants"]');
  if (intro && link) link.textContent = 'Legg til';
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateOrganizerStickyLabel);
else updateOrganizerStickyLabel();
document.addEventListener('shopify:section:load', updateOrganizerStickyLabel);

let productColorScrollFrame;
let productColorScrollIntent;
const rememberProductColorChoice = (event) => {
  if (!event.isTrusted) return;
  if (event.type === 'keydown' && !['Enter', ' ', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  productColorScrollIntent = null;
  const picker = event.target.closest('variant-picker');
  if (!picker || picker.closest('quick-add-drawer')) return;
  const product = picker.closest('.js-product');
  const intro = product?.querySelector('.zs-organizer-intro');
  if (!intro || intro.matches('.zs-bundle-intro, .zs-accessory-intro')) return;
  if (!intro.dataset.zsBackpackFamily && !intro.classList.contains('zs-category-cross-sell')) return;
  const selector = event.target.closest('.option-selector');
  const index = Array.from(picker.optionSelectors || []).indexOf(selector);
  const option = picker.data?.product?.options?.[index];
  const name = typeof option === 'string' ? option : option?.name;
  if (index < 0 || !/farve|färg|farge|colou?r|farbe|väri|kleur/i.test(name || '')) return;
  productColorScrollIntent = {
    picker, product, index,
    previousVariant: picker.variant?.id,
    previousColor: picker.variant?.options?.[index],
    previousMedia: picker.variant?.featured_media?.id,
    expires: Date.now() + 1500
  };
};
document.addEventListener('click', rememberProductColorChoice, true);
document.addEventListener('keydown', rememberProductColorChoice, true);
document.addEventListener('change', rememberProductColorChoice, true);
document.addEventListener('on:variant:change', (event) => {
  const intent = productColorScrollIntent;
  const picker = event.target.closest('variant-picker');
  if (!intent || picker !== intent.picker || Date.now() > intent.expires) return;
  productColorScrollIntent = null;
  const variant = event.detail?.variant;
  if (!variant?.featured_media || variant.id === intent.previousVariant
    || variant.options?.[intent.index] === intent.previousColor
    || variant.featured_media.id === intent.previousMedia) return;
  cancelAnimationFrame(productColorScrollFrame);
  productColorScrollFrame = requestAnimationFrame(() => {
    const media = intent.product.querySelector('#product-media');
    if (!media) return;
    const rect = media.getBoundingClientRect();
    const header = document.querySelector('store-header');
    const offset = Math.min(header?.getBoundingClientRect().height || 0, 160) + 12;
    const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, offset));
    if (visibleHeight >= Math.min(rect.height * 0.85, window.innerHeight - offset - 24)) return;
    window.scrollTo({
      top: Math.max(0, window.scrollY + rect.top - offset),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
